import React, { FC } from 'react';
import { useTerritoryDetailsModalContext } from '../TerritoryDetails/context/TerritoryDetailsModalContextProvider';
import { ShareTerritoryModalContainer } from '../ShareModal/ShareTerritoryModalContainer';

type TShareTerritoryModalComponentProps = {
  territoryName: string;
};

export const ShareTerritoryModalComponent: FC<TShareTerritoryModalComponentProps> = ({ territoryName }) => {
  const { ModalComponent } = useTerritoryDetailsModalContext();

  return (
    <ModalComponent>
      <ShareTerritoryModalContainer territoryName={territoryName} />
    </ModalComponent>
  );
};
